import { render, staticRenderFns } from "./KnOrders.vue?vue&type=template&id=4fd2dbee&"
import script from "./KnOrders.vue?vue&type=script&lang=js&"
export * from "./KnOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports